interface AutofocusBinding {
  modifiers: {
    empty?: boolean;
  };
  value?: boolean;
}

type AutofocusElementTargets = HTMLInputElement | HTMLTextAreaElement | HTMLButtonElement;

export default {
  mounted(el: HTMLElement, { modifiers, value }: AutofocusBinding) {
    const matchesTarget = /input|textarea|button/i.test(el.nodeName);
    const targetElement = matchesTarget
      ? (el as AutofocusElementTargets)
      : el.querySelector<AutofocusElementTargets>('input, textarea, button');

    const isNotEmptyWithModifiers = !!targetElement && !(modifiers.empty && targetElement.value);
    const shouldFocus = isNotEmptyWithModifiers && value !== false;

    if (shouldFocus) {
      targetElement.focus();
    }
  },
};
